module.exports = __webpack_public_path__ + "img/cardGallery1.jpg?ed4d5047deba53061e23fa59a4d31633";